import React from "react";
import TestCard from "../../pages/Dashboard/TestCard";
import Empty from "../../assets/assets/empty.svg";
import Product from "../../pages/Dashboard/Product";
import Expiry from "../Expiry/Expiry";
import { PropTypes } from "prop-types";

const Approved = (props) => {
  const {
    application,
    goToSinglePage,
    status,
    certifiedStatus,
    companyId,
    results,
    resultsLength,
    getStatus,
    categoryChoice,
    testCardStatus,
    userType,
    pos,
    application_info,
    expired
  } = props;

  const cbnExpiryDate = status && status[0] && status[0].cbn_license_expired;

  const posId = pos && pos[0] && pos[0].id;

  return (
    application.nibss_super_admin_status === "approved" &&
    application.status === "approved" && (
      <div>
        {cbnExpiryDate === false &&
          application_info &&
          application_info.length === 0 ? (
            <div className="empty2">
              <div>
                <img src={Empty} alt="empty2" />
              </div>
              <h1>Network Error</h1>
              <p>Please check back later.</p>
            </div>
          ) : (
            <div className="docs-section">
              <h2>
                Based on your application you have access to the listed NIBSS
                product and services
            </h2>
              {application && application.expiry_date && (
                <Expiry
                  days_left={application.days_left}
                  expired={cbnExpiryDate}
                  date={application.expiry_date}
                />
              )}
              <div className="pos-doc-sec">
                <div className="documentation">
                  {application_info &&
                    application_info.map((doc) => (
                      <div className="overlay-holder" key={doc.id}>
                        <Product
                          docUrl={doc.url}
                          id={doc.id}
                          docName={doc.name}
                          goToSinglePage={goToSinglePage}
                          iconUrl={doc.image_url}
                          colorCode={doc.color_code}
                        />
                      </div>
                    ))}
                </div>

                <div className="testcard-main" style={{ marginTop: "30px" }}>
                  <TestCard
                    certifiedStatus={certifiedStatus}
                    appId={posId}
                    userType={userType}
                    companyId={companyId}
                    results={results}
                    resultsLength={resultsLength}
                    getUserStatus={getStatus}
                    categoryChoice={categoryChoice}
                    testCardStatus={testCardStatus}
                    expired={expired}
                  />
                </div>
              </div>
            </div>
          )}
      </div>
    )
  );
};

Approved.propTypes = {
  application: PropTypes.object,
  goToSinglePage: PropTypes.func,
  status: PropTypes.array,
  certifiedStatus: PropTypes.bool,
  companyId: PropTypes.number,
  results: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  resultsLength: PropTypes.array,
  getStatus: PropTypes.func,
  categoryChoice: PropTypes.number,
  testCardStatus: PropTypes.number,
  userType: PropTypes.string,
  pos: PropTypes.array,
  application_info: PropTypes.array
}

export default Approved;
